import _ from 'lodash';
import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { getAuthData } from 'utils/MemberUtils';
import { APOLOGIES_URL } from 'constants/URL';

const _wrapComponent = (componentName, props) => {
  return Wrapee => {
    class Wrapper extends Component {
      render() {
        return <Wrapee { ...this.props } { ...props } />;
      }
    }

    Wrapper.displayName = `${componentName}(${Wrapee.displayName || Wrapee.name || 'Component'})`;

    return Wrapper;
  };
};

const _generateRoutesWithPage = ({ routes = [], page = {} }) => {
  const components = [];

  let requireAuth = null;

  if (process.env.BROWSER) {
    requireAuth = (nextState, replace, callback) => {
      if (!getAuthData()) {
        replace({
          pathname: '/login',
          query: {
            redirect: encodeURIComponent(location.href)
          },
          state: { nextPathname: nextState.location.pathname }
        });
      }
      callback();
    };
  }
  // Adding 404(NotFound) page if 'our-apologies' page doesn't exist
  let redirectRoute = <Route path='*' key='*' component={ require('components/core/NotFoundPage') } />;

  _.forEach(routes, (routeDef, routeId) => {
    const { paths, authenticated } = routeDef;

    let hook = null;

    if (authenticated) {
      hook = requireAuth;
    }

    _.forEach(paths, path => {
      const PageWrapper = _wrapComponent('Page', {
        configPath: `routes[${routeId}]`
      })(require('components/core/Page'));

      components.push(
        <Route
          key={path}
          path={path}
          component={PageWrapper}
          onEnter={hook}
        />
      );

      if (path === APOLOGIES_URL) {
        const redirectPath = `${path}?url=${page.uri}`;
        redirectRoute = <Redirect key={redirectPath} to={redirectPath} from='*' />;
      }
    });
  });

  components.push(redirectRoute);

  return components;
};

export default function (flux) { /* eslint react/display-name: 0 */
  const { config: { routes = [] } = {}, page = {} } = flux.getStore('Ctx').getState();

  return (
    <Route component={ require('components/core/App') }>
      { _generateRoutesWithPage({ routes, page }) }
      <Route path='*' component={ require('components/core/NotFoundPage') } />
    </Route>
  );
}



// WEBPACK FOOTER //
// ./app/routes.js